import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CameraFeed from './CameraFeed';
import {
  Thermometer, Droplets, Wind, Droplet
} from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import ClimateChart from '../components/ClimateChart';
import NDVIMap from '../components/NDVIMap';
import NDVIDrawMap from '../components/NDVIDrawMap';


const Home = () => {
  const [temperature, setTemperature] = useState(null);
  const [soilMoisture, setSoilMoisture] = useState(null);
  const [airHumidity, setAirHumidity] = useState(null);
  const [windSpeed, setWindSpeed] = useState(null);
  const [waterConsumption, setWaterConsumption] = useState(null);
  const [alerts, setAlerts] = useState([]);
  const [diagnostico, setDiagnostico] = useState([]);
  const [ndviImg, setNdviImg] = useState(null);
  const [ndviResultado, setNdviResultado] = useState(null);


  useEffect(() => {
    const fetchData = () => {
      axios.get('https://sense-agro-backend.onrender.com/api/temperature')
        .then(res => setTemperature(res.data.temperature))
        .catch(console.error);

      axios.get('https://sense-agro-backend.onrender.com/api/soil-moisture')
        .then(res => setSoilMoisture(res.data.soil_moisture))
        .catch(console.error);

      axios.get('https://sense-agro-backend.onrender.com/api/air-humidity')
        .then(res => setAirHumidity(res.data.air_humidity))
        .catch(console.error);

      // axios.get('http://18.231.147.65:5000/api/wind-speed')
      //   .then(res => setWindSpeed(res.data.wind_speed))
      //   .catch(console.error);

      // axios.get('http://18.231.147.65:5000/api/consumo-realtime')
      //   .then(res => setWaterConsumption(res.data.water_consumption))
      //   .catch(console.error);

      axios.get('https://sense-agro-backend.onrender.com/api/ai-alerts')
        .then(res => setAlerts(res.data))
        .catch(console.error);

      axios.get('https://sense-agro-backend.onrender.com/api/monitorar-cultura')
        .then(res => setDiagnostico(res.data))
        .catch(console.error);

      axios.get('https://sense-agro-backend.onrender.com/api/analise-satelite?lat=-23.346933&lon=-47.887825')
        .then(res => setNdviImg(res.data.image_base64))
        .catch(console.error);

        
    };
   
    
    fetchData();
    const interval = setInterval(fetchData, 10000);
    return () => clearInterval(interval);
  }, []);
 const handlePerimetroDesenhado = async (coords) => {
      if (!ndviImg || !coords) return;
    
      try {
        const response = await axios.post('https://sense-agro-backend.onrender.com/api/analisar-perimetro', {
          imagem_base64: ndviImg,
          coordenadas: coords,
        });
    
        const resultado = response.data;
        setNdviResultado(resultado);
    
      } catch (err) {
        console.error(err);
        alert('❌ Erro ao processar análise da área.');
      }
    };
  return (
    <div className="min-h-screen w-full bg-slate-900 text-white">
      <main className="px-4 pb-8 pt-4 max-w-[1600px] mx-auto space-y-6">

        {/* Cards principais */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-red-600 p-4 rounded-xl shadow-md">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-lg font-semibold">Temperatura Atual</p>
                <p className="text-3xl font-bold">{temperature ?? '...'}°C</p>
              </div>
              <Thermometer size={32} />
            </div>
          </div>
          <div className="bg-yellow-600 p-4 rounded-xl shadow-md">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-lg font-semibold">Umidade do Solo</p>
                <p className="text-3xl font-bold">{soilMoisture ?? '...'}%</p>
              </div>
              <Droplets size={32} />
            </div>
          </div>
          <div className="bg-sky-600 p-4 rounded-xl shadow-md">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-lg font-semibold">Umidade do Ar</p>
                <p className="text-3xl font-bold">{airHumidity ?? '...'}%</p>
              </div>
              <Droplet size={32} />
            </div>
          </div>
          <div className="bg-orange-600 p-4 rounded-xl shadow-md">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-lg font-semibold">Vento</p>
                <p className="text-3xl font-bold">{windSpeed ?? '...'} km/h</p>
              </div>
              <Wind size={32} />
            </div>
          </div>
        </div>

        {/* Câmera e Diagnóstico */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-slate-800 rounded-xl p-4">
            <h2 className="text-lg font-semibold mb-2">Câmera da Fazenda</h2>
            <div className="overflow-hidden rounded-lg">
              <CameraFeed />
            </div>
          </div>

          <div className="bg-yellow-100 text-yellow-900 rounded-xl p-4 shadow">
            <h2 className="text-lg font-bold mb-2">Diagnóstico de Cultura Atual</h2>
            {diagnostico.length > 0 && (
              <div>
                {diagnostico.map((item, idx) => (
                  <div key={idx} className="mb-2">
                    <p className="font-bold">{item.nome_fazenda} - {item.cultura}</p>
                    <p>Status: {item.status_geral}</p>
                    <ul className="list-disc list-inside text-sm mt-1">
                      {item.recomendacoes.map((r, i) => (
                        <li key={i}>{r}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Alertas da IA */}
        <div className="bg-slate-800 p-4 rounded-xl">
          <h2 className="text-lg font-semibold mb-3">Alertas da IA</h2>
          <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
            <AnimatePresence>
              {alerts.length > 0 ? alerts.map((alert, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.3 }}
                  className="bg-blue-100 text-blue-800 p-4 rounded-lg border-l-4 border-blue-500 shadow"
                >
                  <p className="font-bold">{alert.title}</p>
                  <p className="text-sm">{alert.message}</p>
                </motion.div>
              )) : (
                <div className="text-gray-300">Nenhum alerta no momento.</div>
              )}
            </AnimatePresence>
          </div>
        </div>

        {/* Placeholder para Mapa com Sensores */}
        {/* <div className="bg-slate-800 p-4 rounded-xl">
          <h2 className="text-lg font-semibold mb-3">Sensores no Mapa Satélite</h2>
          <div className="h-60 w-full bg-gray-700 rounded-lg flex items-center justify-center text-gray-300">
          <SatelliteViewer />
          </div>
        </div> */}

        {/* Gráfico climático */}
        <div className="bg-slate-600 p-4 rounded-xl">
          <h2 className="text-lg font-semibold mb-3">Variação Climática</h2>
          <div className="h-80">
          <ClimateChart />
          </div>
        </div>
    {/* Imagem NDVI processada com seleção de perímetro */}
{/* <div className="bg-slate-800 p-4 rounded-xl">
  <h2 className="text-lg font-semibold mb-3">Análise Satélite (NDVI)</h2>
  {ndviImg ? (
    <NDVIDrawMap
    imageUrl={ndviImg}
    onPerimetroDesenhado={async (coords) => {
      try {
        const response = await axios.post('http://18.231.147.65:5000/api/analisar-perimetro', {
          imagem_base64: ndviImg, // 🟢 importante garantir que esta imagem esteja atualizada
          coordenadas: coords
        });
        setNdviResultado(response.data);
      } catch (err) {
        console.error('❌ Erro ao processar análise da área:', err);
      }
    }}
    />
  ) : (
    <p className="text-gray-300">Carregando mapa NDVI...</p>
  )}
</div> */}

{/* Exibição do diagnóstico após análise */}
{/* {ndviResultado && (
  <div className="bg-green-100 text-green-900 p-4 rounded-xl border-l-4 border-green-600 shadow-md">
    <h3 className="text-lg font-bold mb-2">📊 Diagnóstico da Área Selecionada</h3>
    <p><strong>NDVI Médio:</strong> {ndviResultado.ndvi_medio}</p>
    <p><strong>Alerta:</strong> {ndviResultado.alerta}</p>
    <p><strong>Pixels Analisados:</strong> {ndviResultado.quantidade_pixels}</p>
  </div>
)} */}


      </main>
    </div>
  );
};

export default Home;